import { html, repeat, unsafeHTML } from '@resn/gozer-core';
import { Component, componentMixin } from '@resn/gozer-core/component';
import DomComponentMixin from '@resn/gozer-core-mixins/dom-component';
import sidePanelMixin from '../side-panel-mixin';
import store from 'core/store';
import { getUsd } from 'utils/currency';
import { autobind } from 'core-decorators';
import './index.scss';
import Copy from '@resn/gozer-core/copy';
import ShopifyService from 'api/shopify';
import svg from 'component/svg';
import xs1Packages from 'api/shopify/data/xs1-packages';
import xs1PackagesData from 'data/xs1-packages-data';

const data = [
    {
        id: 'flex',
        accessories: new Array(7).fill(),
        exercises: new Array(2).fill(),
    },
    {
        id: 'flow',
        accessories: new Array(10).fill(),
        exercises: new Array(3).fill(),
    },
    {
        id: 'peak',
        accessories: new Array(10).fill(),
        exercises: new Array(2).fill(),
    },
];

const headerContent = ({ props, context }) => html`
    <div class="sidePanel__headerMenu  sidePanel__headerMenuXs1Package  text-heading6">
        ${data.map(
            (item, i) => html`
                <h3
                    class="sidePanel__headerItem sidePanel__headerFade ${props.idx == i + 1
                        ? 'sidePanel__headerHighlight'
                        : ''}"
                    @click="${() => context.onMenuItemClick(item.id)}"
                >
                    ${Copy.get(`xs1-configurator-packages-explore-tab-${i + 1}`)}
                </h3>
            `,
        )}
    </div>
`;

// ${getUsd(props.monthlyPrice)}/month or ${getUsd(props.price)}
const content = ({ props }) => html`
    <div>
        <header class="sidePanel__top ${`sidePanel__top--${props.packageId}`}">
            <div class="sidePanel__topHead">
                <h2 class="text-heading4">${Copy.get(`xs1-configurator-packages-explore-${props.idx}-title`)}</h2>
                <h3 class="text-copyTitle2">${Copy.get(`xs1-configurator-packages-explore-${props.idx}-subtitle`)}</h3>
            </div>

            <div class="sidePanel__topFoot">
                <div class="sidePanel__topFootTitle text-copyTitle1">
                        ${props.monthlyPrice ? getUsd(props.monthlyPrice) : ''}
                </div>
            </div>
        </header>

        <div class="sidePanel__bottom">
            <p>${unsafeHTML(Copy.get(`xs1-configurator-packages-explore-${props.idx}-bodycopy`))}</p>
            <div class="sidePanel__divider m-only"></div>

            <div class="sidePanel__divider"></div>

            <h4>${Copy.get(`xs1-configurator-packages-explore-${props.idx}-exercise`)}</h4>

            ${repeat(
                data[props.idx - 1].exercises,
                (_item, i) => `exercise-${i}`,
                (_item, i) => {
                    const exSubTitle = Copy.get(
                        `xs1-configurator-packages-explore-${props.idx}-exercise-subtitle-${i + 1}`,
                    );
                    const exBody = Copy.get(
                        `xs1-configurator-packages-explore-${props.idx}-exercise-bodycopy-${i + 1}`,
                    );
                    return html`
                        <h5>${exSubTitle}</h5>
                        <p>${exBody}</p>
                    `;
                },
            )}

            <div class="sidePanel__divider"></div>

            <h4>${Copy.get(`xs1-configurator-packages-explore-${props.idx}-accessories`)}</h4>

            <div class="sidePanel__grid">
                ${xs1PackagesData.packages[props.idx - 1].types[0].accessories.map(
                    (item) => html`
                        <div class="sidePanel__gridItem">
                            <div class="sidePanel__gridIcon">${svg(item.id, 'gridIcon__icon')}</div>
                            <label class="text-body3">${item.text}</label>
                        </div>
                    `,
                )}
            </div>

            <div class="sidePanel__divider"></div>

            <h4>${Copy.get(`xs1-configurator-packages-explore-${props.idx}-software`)}</h4>
            <p>${unsafeHTML(Copy.get(`xs1-configurator-packages-explore-${props.idx}-software-bodycopy`))}</p>

            <div class="sidePanel__divider"></div>

            <h4>${Copy.get(`xs1-configurator-packages-explore-${props.idx}-faq`)}</h4>
            <h5>${Copy.get(`xs1-configurator-packages-explore-${props.idx}-faq-subtitle-1`)}</h5>
            <p>${unsafeHTML(Copy.get(`xs1-configurator-packages-explore-${props.idx}-faq-bodycopy-1`))}</p>
            <h5>${Copy.get(`xs1-configurator-packages-explore-${props.idx}-faq-subtitle-2`)}</h5>
            <p>${unsafeHTML(Copy.get(`xs1-configurator-packages-explore-${props.idx}-faq-bodycopy-2`))}</p>
        </div>
    </div>
`;

@componentMixin(DomComponentMixin)
@componentMixin(sidePanelMixin)
class SidePanelXS1Package extends Component {
    options = {
        headerContent,
        content,
    };

    props = {
        packageId: () => store().state.panels.subscriptionPackageId,
        // price: (props) => ShopifyService.getProductByUiid(`xs1-${props.packageId}-black`).price,
        monthlyPrice: (props) => ShopifyService.getProductByUiid(`xs1-${props.packageId}-black`).accessoryPrice,
        idx: (props) => {
            switch (props.packageId) {
                case 'flex':
                    return 1;
                case 'flow':
                    return 2;
                // case 'form':
                //     return 3;
                case 'peak':
                    return 3;
            }
        },
        headerClassName: (props) => `sidePanel__header--${props.packageId}`,
    };

    async onSetup() {
        // console.log('🚀 ~ onSetup ~ xs1PackagesData.packages[2]', xs1PackagesData.packages[1].types[0]);
        // console.log(this.props);
        // debugger;
    }

    @autobind
    onMenuItemClick(id) {
        store().state.panels.subscriptionPackageId = id;
    }

    handleClose() {
        this.options.onClose();
    }
}

export default SidePanelXS1Package;
